import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { BiPlus } from 'react-icons/bi';

const INSERT_OPTIONS = {
  question: { label: 'Question', key: 'question' },
  section: { label: 'Section', key: 'section' },
  subsection: { label: 'Subsection', key: 'subsection' },
};

const InsertAnchor = ({
  anchorId,
  options = ['question'],
  isActive = false,
  onInsertQuestion,
  onInsertSection,
  onInsertSubsection,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const rootRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const handleClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  useLayoutEffect(() => {
    if (!menuOpen) return;
    const rootEl = rootRef.current;
    const menuEl = menuRef.current;
    if (!rootEl || !menuEl) return;
    const rootRect = rootEl.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rootRect.bottom;
    const spaceAbove = rootRect.top;
    setOpenUpward(spaceBelow < menuEl.offsetHeight && spaceAbove > spaceBelow);
  }, [menuOpen]);

  const handleAction = (key) => {
    setMenuOpen(false);
    if (key === 'question') onInsertQuestion?.();
    else if (key === 'section') onInsertSection?.();
    else if (key === 'subsection') onInsertSubsection?.();
  };

  const visibleOptions = options
    .map((key) => INSERT_OPTIONS[key])
    .filter(Boolean);

  const showMenu = visibleOptions.length > 1;
  const singleOption = visibleOptions.length === 1 ? visibleOptions[0].key : null;
  const buttonLabel = visibleOptions.length === 1
    ? visibleOptions[0].label
    : visibleOptions.map(({ label }) => label).join(', ');

  const handleClick = () => {
    if (singleOption) {
      handleAction(singleOption);
      return;
    }
    setMenuOpen((v) => !v);
  };

  return (
    <div
      ref={rootRef}
      className={`builder-insert-anchor${isActive || menuOpen ? ' builder-insert-anchor--active' : ''}`}
    >
      <div className="builder-insert-anchor__line" aria-hidden="true" />
      <button
        type="button"
        className="builder-insert-anchor__btn"
        aria-label={`Add ${buttonLabel}`}
        aria-expanded={menuOpen}
        aria-haspopup={showMenu ? 'menu' : undefined}
        data-anchor-id={anchorId}
        onClick={handleClick}
      >
        <BiPlus aria-hidden="true" />
        <span className="builder-insert-anchor__label">{buttonLabel}</span>
      </button>
      {showMenu && menuOpen && (
        <div
          ref={menuRef}
          className={`builder-insert-anchor__menu${openUpward ? ' builder-insert-anchor__menu--above' : ''}`}
          role="menu"
        >
          {visibleOptions.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              role="menuitem"
              className="builder-insert-anchor__menu-item"
              onClick={() => handleAction(key)}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default InsertAnchor;
